import { actionTypes } from '../constants/actionTypes';
import api from '../services';

export const fetchPostsWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getPosts(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_POSTS, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_POSTS_WP_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_POSTS_WP_FAIL, payload};
    }
};

export const fetchPostWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getPost(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
            }));
        }).catch(error => {
            dispatch(failure({
                data: {},
                error: error.message,
                loading: false,
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_POST, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_POST_WP_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_POST_WP_FAIL, payload};
    }
};

export const fetchStoreWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getPosts(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_STORE, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_STORE_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_STORE_FAIL, payload};
    }
};

export const fetchProductWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getProducts(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_PRODUCT, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_PRODUCT_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_PRODUCT_FAIL, payload};
    }
};

export const fetchOneProductWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getProduct(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false
            }));
        }).catch(error => {
            dispatch(failure({
                data: {},
                error: error.message,
                loading: false
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_ONE_PRODUCT, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_PRODUCT_ONE_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_PRODUCT_ONE_FAIL, payload};
    }
};

export const fetchOneStoreWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getPost(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false
            }));
        }).catch(error => {
            dispatch(failure({
                data: {},
                error: error.message,
                loading: false
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_ONE_STORE, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_STORE_ONE_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_STORE_ONE_FAIL, payload};
    }
};

export const fetchMenus = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getPosts(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_MENUS, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_MENUS_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_MENUS_FAIL, payload};
    }
};

export const fetchCareerWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getPosts(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_CAREER, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_CAREER_WP_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_CAREER_WP_FAIL, payload};
    }
};



// WEBPACK FOOTER //
// ./src/actions/posts.tsx